import React, { useEffect, useState } from "react";

import { getAPI } from "../../../utils/common";
import { SMART_PRICE_DASHBOARD } from "../../../constants/api";

const SmartPriceSuggestions = () => {
  const [loading, setLoading] = useState(false);

  const [suggestions, setSuggestions] = useState([]);

  useEffect(() => {
    loadSuggestions();
  }, []);

  const loadSuggestions = () => {
    setLoading(true);

    getAPI(
      SMART_PRICE_DASHBOARD,

      (res) => {
        if (res.status) {
          setSuggestions(res.data);
        }

        setLoading(false);
      },

      () => {
        setLoading(false);
      },

      {},
    );
  };

  const getTrend = (item) => {
    switch (item.direction) {
      case "increase":
        return {
          className: "t-up",
          icon: "fa-arrow-trend-up",
          text: item.demand_level,
        };

      case "decrease":
        return {
          className: "t-down",
          icon: "fa-arrow-trend-down",
          text: item.demand_level,
        };

      default:
        return {
          className: "t-neutral",
          icon: "fa-minus",
          text: "Stable",
        };
    }
  };

  return (
    <div className="card">
      <div className="card-header">
        <h3>Smart Price Suggestions</h3>

        <div>
          <button className="btn btn-sm btn-light" onClick={loadSuggestions}>
            <i className="fa-solid fa-rotate"></i>
          </button>
        </div>
      </div>

      {loading ? (
        <div className="text-center py-4">
          <i className="fa-solid fa-spinner fa-spin"></i>
        </div>
      ) : suggestions.length === 0 ? (
        <div className="text-center py-4">
          <i className="fa-solid fa-circle-info" style={{ color: "#999" }}></i>

          <p>No pending price suggestions.</p>
        </div>
      ) : (
        <div className="price-list">
          {suggestions.map((item) => {
            const trend = getTrend(item);

            return (
              <div className="price-item" key={item.id}>
                <div className="room-details" style={{ textAlign: "left" }}>
                  <h4>{item.room_name} ({item.room_no})</h4>

                  <span className={`trend-badge ${trend.className}`}>
                    <i className={`fa-solid ${trend.icon}`}></i> {trend.text}
                  </span>
                </div>

                <div className="price-action">
                  <div className="price-compare">
                    <small>
                      Current : ₹{Number(item.current_price).toLocaleString()}
                    </small>

                    <strong>
                      ₹{Number(item.suggested_price).toLocaleString()}
                    </strong>

                    <br />

                    <small
                      style={{
                        color:
                          item.direction === "increase"
                            ? "green"
                            : item.direction === "decrease"
                              ? "red"
                              : "#777",
                      }}
                    >
                      {item.direction === "increase"
                        ? "+"
                        : item.direction === "decrease"
                          ? ""
                          : ""}
                      {item.change_percentage}%
                    </small>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}

      <div className="suggestion-note">
        <i className="fa-solid fa-circle-info"></i>

        <p className="text-muted">
          <strong className="text-danger">Note:</strong> AI price suggestions
          are generated using occupancy, booking trends, festivals and demand
          analysis. Please review suggestions before applying.
        </p>
      </div>
    </div>
  );
};

export default SmartPriceSuggestions;
